import { CardContent } from "@libs/zapi-ui/shadcn";
import { TipTapEditor } from "@/zapi-frontend/widgets/TipTapEditor";
import { LoadingSpinner } from "@libs/zapi-ui/custom";

type TProps = {
  isLoading: boolean;
  isEditable: boolean;
  className?: string;
  projectId: string;
};

const UPLOAD_DOWNLOAD_BUTTONS = false;

export function EditorTab(props: TProps) {
  const { isLoading, isEditable, projectId } = props;

  return (
    <CardContent className={"p-0 flex-1 flex flex-col h-full " + props.className}>
      {UPLOAD_DOWNLOAD_BUTTONS && (
        <div className="flex justify-between items-center mb-4">
          <div className="flex gap-2 items-center flex-wrap">
            {isLoading && (
              <div className="flex items-center text-sm text-gray-500">
                <div className="h-4 w-4 border-t-2 border-blue-500 border-solid rounded-full animate-spin mr-2"></div>
                Loading memo...
              </div>
            )}
          </div>
        </div>
      )}

      {isLoading ? (
        <div className="flex items-center justify-center h-48 text-sm text-gray-500">
          <LoadingSpinner />
          Loading memo...
        </div>
      ) : (
        <TipTapEditor editable={isEditable} autoSave projectId={projectId} />
      )}
    </CardContent>
  );
}
